import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import {
        unref, computed, toRefs, ref,
    } from 'vue';
    import {
        TourProduct, getTourConfirmationType,
    } from '@entities/tourProduct';
    import { Typo } from '@travelata-libs/ui-kit';
    import { ConfirmationType, getConfirmationTypeName, ConfirmationTypeIcon, getConfirmationTypeAdditionals } from '@entities/confirmationType';
    import CheckBoxInputList from '@fr/vue/components/inputs/CheckBoxInputList.vue';

    interface ConfirmationTypeFilterPorps {
        allTourProducts: TourProduct[],
        modelValue: ConfirmationType[],
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ConfirmationTypeFilter',
  props: {
    allTourProducts: null,
    modelValue: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: ConfirmationType[]): void;
        (e: 'change'): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        allTourProducts: TourProduct[],
        modelValue: ConfirmationType[],
    };

    

    
    const confirmationList = computed(() => props.allTourProducts
        .reduce<{ type: ConfirmationType | '', text: string }[]>((acc, tourProduct) => {
            const tourConfirmationType = getTourConfirmationType(tourProduct);
            const isIncludes = acc.map((data) => data.type).includes(tourConfirmationType);
            if(!isIncludes && tourConfirmationType !== ConfirmationType.Cancel && tourConfirmationType !== ConfirmationType.Long) {
                acc.push({ type: tourConfirmationType, text: getConfirmationTypeName(tourConfirmationType) });
            }
            return acc;
        }, []));

    const quickAdditionals = getConfirmationTypeAdditionals(ConfirmationType.Quick);

return { __sfc: true,emit, props, confirmationList, quickAdditionals, ConfirmationTypeIcon, CheckBoxInputList }
}

})